attachEvent('.blog-detail__open-filters', 'click', (ev) => {
  ev.target.closest('.blog-detail').querySelector('.blog-detail__others').classList.add('is-open');
  toggleBodyScrollLock(true);
});

attachEvent('.blog-detail__others-close', 'click', (ev) => {
  ev.target.closest('.blog-detail__others').classList.remove('is-open');
  toggleBodyScrollLock(false);
});
